/* @flow */
import * as React from 'react';

import TextWithSubtext from 'components/TextWithSubtext';
import type { Props as TextWithSubtextProps } from 'components/TextWithSubtext';

import getField from '../ComposableTableField';

export function getTextWithSubtextCellGenerator(input: {
  subtext?: string | Function,
  text: string | Function,
  textWithSubtextProps?: TextWithSubtextProps,
}) {
  return (data: Object) => {
    return (
      <TextWithSubtext
        {...input.textWithSubtextProps}
        subtext={getField(data, input.subtext)}
        subtle>
        {getField(data, input.text)}
      </TextWithSubtext>
    );
  };
}
